(function ($, Drupal, window, document) {

  'use strict';

  Drupal.behaviors.slick = {
    attach: function (context, settings) {

      if (typeof context['location'] !== 'undefined') {

        // See https://flickity.metafizzy.co/options.html
        $('.hero-slides').flickity({
          cellAlign: 'left',
          contain: true,
          prevNextButtons: false,
          pageDots: true,
          autoPlay: 5000
        });

      }

    }
  };

})(jQuery, Drupal, this, this.document);
